import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { ESIGN_GET_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetEsignRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = ESIGN_GET_URL;

  constructor(applicationId) {
    super();

    const paramList = [applicationId];
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
